import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { addJobPreference, fetchJobPreferences, updateJobPreference } from "./JobPreferenceAPI";


const initialState = {
  data: [],
  loading: false,
  error: null,
};

export const fetchJobPreferencesAsync = createAsyncThunk(
  "JobPreference/fetch",
  async () => {
    try {
      const data = await fetchJobPreferences();

      const resp = data?.response;
      // console.log("data's response slice", data.response)
      return resp;
    } catch (error) {
      // return rejectWithValue(error.message);
    }
  }
);


export const updateJobPreferenceAsync = createAsyncThunk(
  "JobPreference/update",
  async ({uuid, jobPreferenceData }, { rejectWithValue }) => {
    try {
      const response = await updateJobPreference(uuid, jobPreferenceData);
      // console.log("Response Slice ", response);
      return response;
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);

export const addJobPreferenceAsync = createAsyncThunk(
  "JobPreference/add",
  async ({newJobPreference}) => {
    try {
      const data = await addJobPreference(newJobPreference);
      console.log("data in slice add", data);
      return data;
    } catch (error) {
      console.log("errorL :", error);
    }
  }
);

const JobPreferenceSlice = createSlice({
  name: "JobPreferences",
  initialState,
  reducers: {
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchJobPreferencesAsync.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchJobPreferencesAsync.fulfilled, (state, action) => {
        state.loading = false;
        state.data = action.payload;
        // console.log("DAta", action.payload)
        state.error = null;
      })
      .addCase(fetchJobPreferencesAsync.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload || action.error.message;
      })
      .addCase(addJobPreferenceAsync.fulfilled, (state, action) => {
        state.loading = false;
        if (Array.isArray(state.data)) {
          state.data?.push(action.payload);
        } else {
          state.data = [action.payload]; // Initialize as an array if it's not already
        }
      })
      .addCase(addJobPreferenceAsync.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error?.message || "Failed to add project";
      })

      
      .addCase(updateJobPreferenceAsync.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(updateJobPreferenceAsync.fulfilled, (state, action) => {
        state.loading = false;
      
        if (Array.isArray(state.data)) {
          const updatedIndex = state.data.findIndex(
            (jobPreferenceData) => jobPreferenceData.uuid === action.payload.uuid
          );
      
          if (updatedIndex !== -1) { 
            state.data[updatedIndex] = action.payload;
          }
        } else {
          state.data = [action.payload]; 
        }
      })
      
      .addCase(updateJobPreferenceAsync.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error?.message || "Failed to update project";
      })
  },
});

export const selectJobPreference = (state) => state.jobPreference?.data?.job_preference;

export default JobPreferenceSlice.reducer;
